import DomainIcon from '@material-ui/icons/Domain';

import OrganizationList from './list';
import OrganizationShow from './show';
import OrganizationCreate from './create';
import OrganizationEdit from './edit';

export default {
    list: OrganizationList,
    show: OrganizationShow,
    create: OrganizationCreate,
    edit: OrganizationEdit,
    icon: DomainIcon
};